module.exports = __webpack_public_path__ + "media/images/emblems/Soyhieres-Blazono-d54fb517b80e36c3c7f80ff900664d53.png";